module.exports = __webpack_public_path__ + "img/IMG-20200303-WA0029.713c12cb.jpg";